import { subscriptionsCrudStateConfig } from "seneca-common/features/subscriptions/state/consts";
import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

const subscriptionsMetaReducer = makeCrudStateReducer(
  subscriptionsCrudStateConfig
);
export default subscriptionsMetaReducer;
